class ColourSwatches extends HTMLElement {
  constructor() {
    super();
    
    this.container = this.querySelector('.colour-swatches__container');

    if (this.classList.contains("locked")) {
      return;
    }
    
    this.setSettings().then(settings => {
      const self = this;
      
      this.classList.add('locked');
      
      if (settings == null) {
        this.classList.remove('locked');
        throw 'Empty settings!';
      }
      
      const collection = "all";//settings.currentCollection ? settings.currentCollection : "all";
      
      let url = `${window.routes.root_url}products/${encodeURIComponent(settings.handle)}?view=json`;
      
      if (settings.groupTag && settings.groupTag !== "undefined") {
        url = `${window.routes.collections_url}/${collection}/${encodeURIComponent(settings.groupTag)}?view=json`;
      }
      
      fetch(url).then((response) => response.json())
          .then((responseJson) => {
            self.container.classList.add("loaded");
            if (!Array.isArray(responseJson)) {
              responseJson = responseJson.products;
            }
            if (responseJson.length <= 1) {
              self.classList.add("hidden");
              self.nextElementSibling?.classList.remove("hidden");
            } else {
              if (window.location.href.search("/products") === -1) {
                self.nextElementSibling?.classList.add("hidden");
              }
              self.initSwatches(responseJson, settings);
              self.initMainImages(responseJson, settings);
            }
            
            self.classList.remove('locked');
          });
    })
        .catch((e) => { console.log(e)});
  }
  
  setSettings() {
    const self = this;
    
    const promise = new Promise(function(resolve, reject) {
      var interval = setInterval(function(){
        const settingsRawJson = self.querySelector("#swatches-settings");
        if(!settingsRawJson) return {}
        if (settingsRawJson.innerHTML !== "") {
          clearInterval(interval);
          resolve(JSON.parse(settingsRawJson.innerHTML));
        }
      }, 100);
      window.setTimeout(function() {
        clearInterval(interval);
        resolve(null);
      }, 3000);
    });
    
    return promise;
  }
  
  initMainImages(products, settings) {
    
    let images = document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}'] .new-swatch-images`);
    if (images) return;
    
    let html = "";
    products.forEach(product => {
      let variant = product.variants[0];
      if (variant.featured_image) {
        html += `<img 
          data-variant-id="${variant.id}"
          data-sizes="auto" 
          src="${variant.featured_image.src}"
          data-src="${variant.featured_image.src}"
          alt="${variant.title}" 
          class="fade-in new-swatch-images" />`
      }
    });
    
    let mainImage = document.querySelectorAll(`.product-grid-item__image[data-product-id='${settings.id}'] img`)[0];
    
    if (mainImage) {
      mainImage.classList.remove('blur-up');
      mainImage.classList.remove('fade-in');
    }
    
    if (document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`)) {
      document.querySelector(`.product-grid-item__image[data-product-id='${settings.id}']`).innerHTML += html;
    }
  }

  initSwatches(products, settings) {
    let html = "";
    let moreSwatchesCount = 0;
    const maxVisibleSwatches = 4; // Maximum number of visible swatches
    const gridItemDetails = this.closest('.product-grid-item__details');
    const isInsideDetails = gridItemDetails !== null;
    const variantSwatches = gridItemDetails ? gridItemDetails.querySelector('.product-variant-swatches') : null;

    products.forEach((product, index) => {
      const variant = product.variants[0];
      const img = this.getProductImage(product, settings);
      let isSelectedClass = '';

      if (settings.handle === product.handle) {
        isSelectedClass = 'selected';
      }

      if (variantSwatches) {
        variantSwatches.classList.add("hidden");
      }

      product.hasNullPrice = product.price === 0;

      // Use the variant option 1 value as the color name
      let colorName = '';
      if (variant && variant.option1) {
        colorName = variant.option1;
      } else {
        colorName = product.title;
      }

      const el = `<a class="product-grid-item__swatch-container--new ${isSelectedClass}" data-product-id="${product.id}" data-variant-id="${variant.id}" data-hasnullprice=${product.hasNullPrice} data-available="${product.available}" data-handle="${product.handle}" data-color-name="${colorName}" href="${product.url}"><span class="swatch-circle">${img}</span></a>`;

      if (isInsideDetails) {
        if (index < maxVisibleSwatches) {
          html += el;
        } else {
          moreSwatchesCount++;
        }
      } else {
        html += el;
      }
    });

    // Only add more-swatches element if inside .product-grid-item__details
    if (isInsideDetails && moreSwatchesCount > 0) {
      const moreSwatchesEl = `<span class="more-swatches" href="${products[0].url}">+ ${moreSwatchesCount}</span>`;
      html += moreSwatchesEl;
    }

    if (html) {
      this.container.innerHTML = html;
    }
  }

  
  getProductImage(product, settings) {
    var imageSrc = product.featured_image;
    switch (settings.image_type) {
      case "image_swatch":
        const colourTag = product.tags.find(tag => {
          const lowerTag = tag.toLowerCase();
          const lowerPrefix = settings.colourTagPrefix.toLowerCase();
          return lowerTag.indexOf(lowerPrefix) > -1;
        });
        if(colourTag) {
          const colour = colourTag.replace(new RegExp(`^${settings.colourTagPrefix}`, 'i'), "").toLowerCase();
          imageSrc = "https:" + settings.swatchUrl.replace("swatch", `colour-${colour}`);
        }
        break;
      case "first_variant_image":
        const firstVariantImage = product.variants[0].image;
        if(firstVariantImage) imageSrc = firstVariantImage;
        break;
      case "last_variant_image":
        const lastVariantImg = product.variants[product.variants.length - 1].image;
        if(lastVariantImg) imageSrc = lastVariantImg;
        break;
      default:
        break;
    }
    return `<img src="${imageSrc}" width="40" alt=""/>`;
  }
  }
customElements.define('colour-swatches', ColourSwatches);
